import classNames from "classnames";
import PropTypes from "prop-types";
import { FaPlus, FaMinus } from "react-icons/fa6";
import styles from "@/components/FooterSection/index.module.scss";

const FooterAccordion = ({
  header,
  children,
  isActive,
  isHeader,
  isNavHeader,
  isTopNavMobile,
  isTopNavMobileLogo,
  handleToggle,
  open,
}) => {
  const activeHeadingClass = `${styles.footerAccordionHeading} flex justify-between text-footertext font-['Helvetica'] text-[14px] uppercase cursor-default`;

  const footerHeadingClass = classNames(
    "flex flex-1 font-semibold justify-between items-center",
    { [activeHeadingClass]: isActive },
    {
      "my-1 flex justify-between font-['Helvetica'] text-[16px] uppercase cursor-default":
        isNavHeader,
    },
    {
      "font-['Helvetica'] text-[16px] uppercase cursor-default  font-medium":
        isTopNavMobile,
    },
    {
      "font-['Helvetica'] text-[16px] cursor-default  font-medium":
        isTopNavMobileLogo,
    }
  );

  return (
    <div
      className={classNames("mx-auto select-none max-w-full", {
        "hidden min-[819px]:hidden": header?.toLowerCase() === "social",
      })}
    >
      <div
        className={classNames("", {
          "bg-[#232323] border-b-[1px] border-[#666]": isActive,
          "bg-[#999999]": isNavHeader,
        })}
      >
        <button
          className={classNames("!w-full", {
            "flex p-3.5 flex-wrap items-center list-none cursor-pointer":
              isHeader,
            "flex border-b-[1px] border-[#666] flex-wrap items-center list-none cursor-pointer":
              isNavHeader,
            "flex py-7 px-5 bg-sidebar flex-wrap items-center list-none cursor-pointer":
              !isHeader,
          })}
          onClick={() => handleToggle(header)}
        >
          <h4 className={footerHeadingClass}>
            {header} {!open ? <FaPlus /> : <FaMinus />}
          </h4>
        </button>

        {/*Changing this to below coz Cookie modal does open for smaller screens*/}
        <div
          style={{
            display: open ? "block" : "none",
            paddingBlock: "10px 25px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

FooterAccordion.propTypes = {
  isActive: PropTypes.bool,
  isNavHeader: PropTypes.bool,
  isTopNavMobile: PropTypes.bool,
  isTopNavMobileLogo: PropTypes.bool,
  isHeader: PropTypes.bool,
  header: PropTypes.string,
  handleToggle: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node,
};

export default FooterAccordion;
